





























































































































import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { MetaInfo } from 'vue-meta';
import { Resolve } from 'vue-di';
import { faPrescription, faChevronUp, faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import { mapKeys } from 'lodash';
import Header from '~/components/common/Header/Header.vue';
import Footer from '~/components/common/Footer/Footer.vue';
 
import theme from '~/settings/theme';
import SessionModule from '~/store/session';
import SectionModule from '~/store/section';
 
 
@Component<DefaultLayout>({
    components: {
        Header,
        Footer,
    },      
    mounted() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if ((this as any).$meta) (this as any).$meta().refresh();
       
        // Check for E-Consent parameter in various formats
        const routeQuery = this.$route.query;
        const routePath = this.$route.path;
       
        // Check for query parameter in various formats
        const isEconsentPath =
            routeQuery.path === 'econsent' || // Standard format: ?path=econsent
            routePath.includes('/path=econsent') || // Unusual format: /path=econsent
            routePath.includes('/?path=econsent') || // Another format with slash
            routeQuery.econsent === '' || // Possible format: ?econsent
            routeQuery.econsent === 'true'; // Possible format: ?econsent=true
           
        // Only run E-Consent specific logic if we're on an E-Consent path
        if (isEconsentPath) {
             // Add route guard to handle navigation
            this.$router.beforeEach((to, from, next) => {
            // End any existing loaders to prevent stuck loading state
            if (this.$wait.is('nuxt')) {
                this.$wait.end('nuxt');
            }
            next();
        });
        }
    },
    icons: {
        faPrescription,
        faChevronUp,
        faChevronDown,
    },
})
export default class DefaultLayout extends Vue {
 
    @Resolve
    public session!: SessionModule;
   
    @Resolve
    public sectionStore!: SectionModule;
   
    public theme = theme;

    public get normalizedPath(): string {
        const path = this.$route.path;
        return path.length > 1 && path.endsWith('/') ? path.slice(0, -1) : path;
    }

    created() {
        try {
            // Handle E-Consent parameter case - check multiple possible formats
            const routeQuery = this.$route.query;
            const routePath = this.$route.path;
           
            // Check for query parameter in various formats
            const isEconsentPath =
                routeQuery.path === 'econsent' || // Standard format: ?path=econsent
                routePath.includes('/path=econsent') || // Unusual format: /path=econsent
                routePath.includes('/?path=econsent') || // Another format with slash
                routeQuery.econsent === '' || // Possible format: ?econsent
                routeQuery.econsent === 'true'; // Possible format: ?econsent=true
               
            // Only run E-Consent specific logic if we're on an E-Consent path
            if (isEconsentPath) {
                // Find Patient section (id: 111)
                const patientSection = this.sectionStore.SECTIONS.find(section => section.id === 111);
                if (patientSection) {
                    // Find the E-Consent option (id: 3)
                    const eConsentOption = patientSection.options.find(option => option.id === 3);
 
                    if (eConsentOption) {
                        // Set the E-Consent path in the store
                        this.sectionStore.handleSelectionPath({
                            section: patientSection,
                            optionIndex: patientSection.options.indexOf(eConsentOption)
                        });                        
                       
                        // Analyze current path
                        const currentPath = this.$route.path;
                        const isSpecialPage =
                            currentPath === '/' ||
                            currentPath === '/success' ||
                            currentPath === '/success/' ||
                            currentPath === '/patient/patient-authorization-success' ||
                            currentPath === '/patient/patient-authorization-success/' ||
                            currentPath === '/not-eligible' ||
                            currentPath === '/thank-you' ||
                            currentPath === '/error' ||
                            currentPath === '/upload-documents-success' ||
                            currentPath === '/upload-documents-success/' ||
                            currentPath === '/pharmacy/pharmacy-information-success' ||
                            currentPath === '/pharmacy/pharmacy-information-success/';
                        // Check if current path is part of E-Consent flow
                        const isEConsentPage = eConsentOption.menuItems.some(item => {
                            // Normalize both paths by ensuring they start with / and end with /
                            const menuPath = '/' + item.route.replace(/^\/|\/$/g, '') + '/';
                            const routePath = '/' + currentPath.replace(/^\/|\/$/g, '') + '/';
                            return routePath.includes(menuPath);
                        });
                           
                        // Only redirect if we're not already on an E-Consent page
                        if (isSpecialPage || !isEConsentPage) {                          
                            // Start loader and redirect
                            this.$wait.start('nuxt');
                            this.ensureLoadingEndsAfterTimeout();
                           
                            // Use push instead of replace for more consistent navigation behavior
                            this.$router.push({
                                path: eConsentOption.menuItems[0].route,
                                query: { path: 'econsent' }
                            }).catch(error => {
                                // Handle navigation errors
                                console.error('Navigation error:', error);
                                this.$wait.end('nuxt');
                            });
                        } else {
                            console.warn('Already on E-Consent page, no redirect needed');
                        }
                        return;
                    }
                }
               
                // Check if we were previously on E-Consent path but now the parameter is missing
                const wasOnEconsentPath = this.sectionStore.activeUniqueMenuItems && this.sectionStore.activeUniqueMenuItems.id === 3; // E-Consent option ID
                const missingEconsentParam = !isEconsentPath && wasOnEconsentPath;
                // Handle case when previously on E-Consent but parameter is now missing
                // Skip redirect for success page
                const currentPath = this.$route.path;
                const isSuccessPage =
                    currentPath === '/' ||
                    currentPath === '/success' ||
                    currentPath === '/success/' ||
                    currentPath === '/patient/patient-authorization-success' ||
                    currentPath === '/patient/patient-authorization-success/' ||
                    currentPath === '/not-eligible' ||
                    currentPath === '/thank-you' ||
                    currentPath === '/error' ||
                    currentPath === '/upload-documents-success' ||
                    currentPath === '/upload-documents-success/' ||
                    currentPath === '/pharmacy/pharmacy-information-success' ||
                    currentPath === '/pharmacy/pharmacy-information-success/';
                   
                if (missingEconsentParam && !isSuccessPage && currentPath !== '/') {
                    this.sectionStore.resetSelections();
                    this.$wait.start('nuxt');
                    this.$router.push('/');
                    return;
                }
            }
        } catch (error) {
            console.error('Error in normal layout created hook:', error);
        }
    }
 
    // Helper method to prevent infinite loading
    private ensureLoadingEndsAfterTimeout() {
        // End the loader after a maximum of 5 seconds to prevent infinite loading
        setTimeout(() => {
            if (this.$wait.is('nuxt')) {
                this.$wait.end('nuxt');
            }
        }, 5000);
    }
 
    // Allows user to close the configuration drawer by hitting escape
 
 
    public get menu(): object {
        return this.$settings.mainMenu;
    }
    public back() {
        this.$router.back();
    }
 
    public get brkPoints() {
        return {
            'brk-xs': this.$vuetify.breakpoint.xs,
            'brk-xs-only': this.$vuetify.breakpoint.xsOnly,
            'brk-sm': this.$vuetify.breakpoint.sm,
            'brk-sm-only': this.$vuetify.breakpoint.smOnly,
            'brk-sm-and-down': this.$vuetify.breakpoint.smAndDown,
            'brk-sm-and-up': this.$vuetify.breakpoint.smAndUp,
            'brk-md': this.$vuetify.breakpoint.md,
            'brk-md-only': this.$vuetify.breakpoint.mdOnly,
            'brk-md-and-down': this.$vuetify.breakpoint.mdAndDown,
            'brk-md-and-up': this.$vuetify.breakpoint.mdAndUp,
            'brk-lg': this.$vuetify.breakpoint.lg,
            'brk-lg-only': this.$vuetify.breakpoint.lgOnly,
            'brk-lg-and-down': this.$vuetify.breakpoint.lgAndDown,
            'brk-lg-and-up': this.$vuetify.breakpoint.lgAndUp,
            'brk-xl': this.$vuetify.breakpoint.xl,
            'brk-xl-only': this.$vuetify.breakpoint.xlOnly,
        };
    }
}
